<app-portlet>
    <app-portlet-header [title]="mapTitle" class="portlet-header" [hideDefaultTools]="true">
    </app-portlet-header>
    <app-portlet-body class="portlet-body hierarchy-map-body">
        <app-map class="full-size" [mapContainerCss]="'full-size'" [markersLocations]="markerLocations"
            (selectedMarkrId)="onMakrerSelected($event)"></app-map>
    </app-portlet-body>
</app-portlet>
